import React__default from 'react';
import { useIntl } from '@grandvisionhq/state';
import { SunglassesRxableSelect } from './SunglassesRxableSelect.js';
import { WITHOUT_RX, WITH_RX } from './types.js';
import { useSunglassesEcommContext } from '../../context/SunglassesEcommContext.js';
import { isRxRadioSelection } from '../RxableSelect/is-rx-radio-selection.js';
import { ProductAnalyticsEvents } from '../../../../Analytics/events/ProductAnalyticsEvents.js';

const SunglassesRxableSelectContainer = ({ className  })=>{
    const { selectWithRxLens , setSelectWithRxLens  } = useSunglassesEcommContext();
    const { getLabel  } = useIntl();
    const radioButtonItems = React__default.useMemo(()=>[
            {
                value: WITHOUT_RX,
                label: getLabel('products.selectRxAble.withoutRx'),
                iconName: 'sunglasses'
            },
            {
                value: WITH_RX,
                label: getLabel('products.selectRxAble.withRx'),
                iconName: 'store-eye-test'
            }, 
        ]
    , [
        getLabel
    ]);
    const onRxRadioChange = React__default.useCallback((newSelection)=>{
        if (isRxRadioSelection(newSelection) && selectWithRxLens !== newSelection) {
            setSelectWithRxLens(newSelection);
            ProductAnalyticsEvents.pushPdpSunglassesRxSelectionEvent(newSelection === WITH_RX);
        }
    }, [
        selectWithRxLens
    ]);
    return /*#__PURE__*/ React__default.createElement(SunglassesRxableSelect, {
        items: radioButtonItems,
        onChange: onRxRadioChange,
        selectedValue: selectWithRxLens,
        className: className
    });
};

export { SunglassesRxableSelectContainer };
//# sourceMappingURL=SunglassesRxableSelectContainer.js.map
